import React from 'react';
import { SmartContainer } from '../../../styles/Containers';
import { StyledList } from '../../../styles/matieralui/List';
import { NavItem } from '../../../components/Navigation/MainNav';
import { FullUI } from '../../../redux/UI/ui.selectors';
import { AccountCircleOutlined, CreditCard, ExitToAppOutlined, HomeOutlined, LanguageOutlined, PeopleOutline, SwapCalls } from '@mui/icons-material';
import { IconLocation, IconPerson, IconPhotoAlbum, IconPhotoLibrary, IconSaveOutlined, IconSettings, IconTeam } from '../../Icons';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { StyledB } from '../../../styles/StyledHTML';
import { NetworkRole, Role } from '../../../redux/Auth/auth.selectors';
import { config } from '../../../config';
import { FullNetwork } from '../../../redux/Network/network.selectors';
import { attemptLogout } from '../../../redux/Auth/auth.actions';
import styled, { css } from 'styled-components';
const SmallNav = styled(SmartContainer)`

    transform: scale3d(0.85,0.85,0.85);
    @media(max-width:768px){
        transform:none;
    }
`


export const SettingsNavigation = () => {
    const ui = FullUI();
    const open = true
    const dispatch = useDispatch();
    const handleSelect = (to, e) => dispatch(push(to));
    const currentUserRole = Role();
    const fullNetwork = FullNetwork();
    const currentNetworkRole = NetworkRole(fullNetwork.network?.id);
    const handleLogout = () => dispatch(attemptLogout());
    return (
        <SmallNav>


            {currentUserRole === 'owner' && (<NavItem onClick={handleSelect} tooltip="Account" open={open} text="Account" to="/settings/account" icon={<IconSettings />} />)}
            <NavItem onClick={handleSelect} tooltip="Manage Your Profile" open={true} text="My Profile" to="/profile" icon={<AccountCircleOutlined />} />
            {currentUserRole === 'owner' && (<NavItem onClick={handleSelect} tooltip="Manage Your Subscription" open={true} text="Billing" to="/billing" icon={<CreditCard />} />)}
            {config.allowTeammates === true && (currentUserRole === 'owner' || currentUserRole === 'admin') && (<NavItem onClick={handleSelect} tooltip="Manage Your Team" open={true} text="Team" to="/team" icon={<IconTeam />} />)}
            {config.allowMultipleAccounts === true && (<NavItem onClick={handleSelect} tooltip="Switch Accounts" open={true} text="Switch Accounts" to="/accounts" icon={<SwapCalls />} />)}
            {currentNetworkRole && currentNetworkRole !== 'norole' && (<NavItem onClick={handleSelect} tooltip="Network Settings" open={true} text="Network" to="/network" icon={<LanguageOutlined />} />)}
            <NavItem onClick={handleLogout} tooltip="Signout of Your Account" open={true} text="Log Out" to="/logout" icon={<ExitToAppOutlined />} />

        </SmallNav>
    )
}